export default function SpySection() {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6">
      <h2 className="text-xl font-bold text-white bg-gradient-to-r from-red-600 to-red-500 px-4 py-2 rounded mb-4">
        Secret Tips
      </h2>
      <div className="text-center mb-4">
        <img 
          src="https://www.zeankickoff1.com/images/spy.gif" 
          alt="Secret Tips" 
          className="mx-auto h-16"
        />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead>
            <tr className="bg-red-600 text-white">
              <th className="border border-gray-300 px-3 py-2 text-center">26 January 2025</th>
              <th className="border border-gray-300 px-3 py-2 text-center" colspan="4">
                Send FS to 4899101 (Only 6 Baht)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-black text-red-500">
              <td className="border border-gray-300 px-3 py-2 text-center">25 January 2025 (2)</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Bologna</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Paderborn</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Famalicao</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Hearts</td>
            </tr>
            <tr className="bg-black text-red-500">
              <td className="border border-gray-300 px-3 py-2 text-center">25 January 2025 (1)</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Lyon</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Barcelona</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Rangers</td>
              <td className="border border-gray-300 px-3 py-2 text-center">Celta Vigo</td>
            </tr>
          </tbody>
        </table>
        <p className="text-center mt-3 text-sm">
          <strong className="text-red-600">Red = Selected Team</strong><br/>
          <strong>*Receive messages between 15:00 to 17:00 daily*</strong>
        </p>
      </div>
    </div>
  );
}